import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { ArrowRight, Package } from "lucide-react";

export default function Bundles() {
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/bundles").then((r) => setBundles(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <section className="border-b border-brand-line">
        <div className="container-narrow py-16 md:py-24">
          <span className="overline text-brand-rust" data-testid="bundles-overline">Editor's Picks</span>
          <h1 className="font-display text-5xl md:text-6xl mt-4 text-brand-ink">Bundles</h1>
          <p className="mt-4 text-brand-inkMuted max-w-2xl leading-relaxed">
            Hand-picked collections of books and courses, sold together at a deliberate discount. Built for leaders who'd rather buy a shelf than browse one.
          </p>
        </div>
      </section>

      <section className="container-narrow py-16">
        {loading ? (
          <div className="overline text-brand-inkMuted text-center py-20">Loading…</div>
        ) : bundles.length === 0 ? (
          <div className="border border-brand-line bg-white p-16 text-center" data-testid="bundles-empty">
            <Package className="w-8 h-8 mx-auto text-brand-inkMuted" />
            <p className="font-serif text-2xl mt-4 text-brand-ink">No bundles yet.</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {bundles.map((b, i) => (
              <Link
                key={b.bundle_id}
                to={`/bundles/${b.slug}`}
                data-testid={`bundle-card-${b.slug}`}
                className="group bg-white border border-brand-line hover:-translate-y-1 hover:shadow-md transition-all duration-300 flex flex-col"
                style={{ animationDelay: `${i * 60}ms` }}
              >
                <div className="aspect-[16/10] overflow-hidden bg-brand-bg">
                  <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center justify-between mb-3">
                    <span className="overline text-brand-rust">{b.products.length} items</span>
                    {b.badge && <span className="overline text-brand-rust">{b.badge}</span>}
                  </div>
                  <h3 className="font-serif text-2xl text-brand-ink leading-snug">{b.title}</h3>
                  {b.subtitle && <p className="mt-1 text-sm text-brand-inkMuted">{b.subtitle}</p>}
                  <div className="mt-auto pt-5 flex items-end justify-between border-t border-brand-line">
                    <div>
                      <p className="overline text-brand-inkMuted">Bundle price</p>
                      <p className="font-serif text-3xl text-brand-ink">${b.bundle_price.toFixed(0)}</p>
                    </div>
                    <div className="text-right">
                      <p className="overline text-brand-inkMuted line-through">${b.list_total.toFixed(0)}</p>
                      <p className="overline text-brand-rust mt-1">Save ${b.savings.toFixed(0)}</p>
                    </div>
                  </div>
                  <span className="mt-4 overline text-brand-rust group-hover:translate-x-1 transition-transform inline-flex items-center gap-1">
                    Explore bundle <ArrowRight className="w-3 h-3" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
